export default __webpack_public_path__ + "images/53_2_image.jpg";